'use strict';

export class BlockVolunteerEvents {
    constructor() {
        // The MyABA Association feed


        var block = $('.block-views-blockgroup-nodes-local-group-block-volunteer-events');
        if (block.length < 1 || block.find('.volunteer-events--meta').length < 1) return;
        var $max_to_display = 3;
        var meta = block.find('.volunteer-events--meta').data();
        var template = block.find('.template .upcoming-event');
        var currentBranch = $('.current_member_branch').data('branch');

        // Get the data from Endpoint
        $.ajax({
            url: meta.src,
            method: 'GET',
            success: function (response) {

                // Sort date ascending
                response.sort(function (a, b) {
                    return a.sort_date.localeCompare(b.sort_date);
                });

                // Display the data
                if ($(response).length > 0) {
                    processAndDisplay(response)
                }
            },
            error: function (error) {
                console.error(error);
            }
        })

        function processAndDisplay(response) {

            // Go over each item and check if needs to be displayed
            var $counter = 0;
            response.forEach(item => {
                
                if ($counter >= $max_to_display) return; // Stop if reached max
                if (!isMyBranch(item.branch)) return; // don't add to view if branch is present and it is not in user current branch
                
                item.event_type = item.event_type.toLowerCase();
                
                var templateClone = template.clone();

                templateClone.attr('data-group', item.event_group);
                templateClone.find("*[data-attr]").each(function (index) {
                    var attr = $(this).data('attr');
                    $(this).html(item[attr]);
                });

                templateClone.find('.views-field-view-node .field-content').html(
                    `<a href='${item.url}' hreflang='en'>More info</a>`
                );

                block.find('.volunteer-events--body .view-content').append(templateClone);
                block.css('display', 'block');

                $counter++;

            });
            
            block.find('.view-footer a').attr('href', '/reminders-and-association-calendar');

        }

        // Check if Branch is empty or is valid
        function isMyBranch(branch) {
            if (branch == "") return true;
            return branch == currentBranch;
        }
    }
}
